// extracted by mini-css-extract-plugin
export default {"nodeContainer":"style_nodeContainer__rkrtn","titleNode":"style_titleNode__MVLBn","price":"style_price__Yu-tz"};